function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 4.48,
  d: "M2.69 41.24v20.05h20.05M41.25 61.32H61.3V41.27M61.34 22.76V2.71H41.28M22.78 2.68H2.72v20.05"
});

function SvgFullScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+ZnVsbC1zY3JlZW48L3RpdGxlPjxwb2x5bGluZSBwb2ludHM9IjIuNjkgNDEuMjQgMi42OSA2MS4yOSAyMi43NCA2MS4yOSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI0LjQ4Ii8+PHBvbHlsaW5lIHBvaW50cz0iNDEuMjUgNjEuMzIgNjEuMyA2MS4zMiA2MS4zIDQxLjI3IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjQuNDgiLz48cG9seWxpbmUgcG9pbnRzPSI2MS4zNCAyMi43NiA2MS4zNCAyLjcxIDQxLjI4IDIuNzEiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iNC40OCIvPjxwb2x5bGluZSBwb2ludHM9IjIyLjc4IDIuNjggMi43MiAyLjY4IDIuNzIgMjIuNzMiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iNC40OCIvPjwvc3ZnPg==";
export { SvgFullScreen as ReactComponent };